import React from 'react';

function Navigation() {
  return (
    <nav className="fixed top-0 w-full z-50 bg-background/80 backdrop-blur-md border-b border-white/5">
      <div className="flex justify-between items-center max-w-[1100px] mx-auto px-8 py-6">
        <span className="text-headline-md font-semibold tracking-tight text-on-background">
          Nick Bitzer
        </span>
        <div className="hidden md:flex items-center gap-10">
          <a
            href="#experience"
            className="text-label-sm text-on-surface-variant hover:text-primary transition-colors duration-300 uppercase tracking-widest"
          >
            Experience
          </a>
          <a
            href="#contact"
            className="text-label-sm text-on-surface-variant hover:text-primary transition-colors duration-300 uppercase tracking-widest"
          >
            Contact
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;